import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {LocalStorageService} from 'angular-2-local-storage';
import {AccountService} from '../../../services/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {NgForm} from '@angular/forms';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-email-change',
  templateUrl: './email-change.component.html',
  styleUrls: ['./email-change.component.scss']
})
export class EmailChangeComponent extends CommonComponent implements OnInit {
  email: string = null;
  password: string = null;
  showPassword: boolean;

  constructor(
    private localStorageService: LocalStorageService,
    private accountsService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
  }

  submit(form: NgForm) {
    this.loadingModalOn();
    this.accountsService.emailChange(this.password, this.email).subscribe(
      (response: any) => {
        this.loadingModalOff();
        this.msgSuccess(this.translate.instant('accounts.email_change.message_success'));
        this.email = null;
        this.password = null;
        form.resetForm();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
}
